
import axios from 'axios'
import { useEffect, useState } from 'react'
import { MdDelete } from "react-icons/md";
import { Link } from 'react-router-dom';
import { FaEdit } from "react-icons/fa";
export default function Customersdata() {
  const [people, setPeople] = useState([])
  useEffect(() => {
  axios.get(process.env.REACT_APP_API_URL+'/api/customer/customers').then((res) => { 
    console.log(res.data)
    setPeople(res.data)
  }).catch((err) => {
    console.log(err)
  }) 
  }, [])
  
  return (
    <>
    <div className="h-10 m-0 p-0 bg-slate-500 opacity-30" style={{borderRadius:'4px'}}>
          <input type="text" className=" m-2" style={{borderRadius: '4px'}} placeholder="Search"/>
        </div>
      <section className="mx-auto w-full max-w-7xl px-4 py-4">
        <div className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
          <div>
            <h2 className="text-lg font-semibold">Customers</h2>
            <p className="mt-1 text-sm text-gray-700">
              This is a list of all Customers
            </p>
          </div>
            <Link to="./addcustomer">
              <button
                type="button"
                className="rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
              >
                Add Customer
              </button>
            </Link>
        </div>
        <div className="mt-6 flex flex-col">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
              <div className="overflow-hidden border border-gray-200 md:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-sm font-normal text-gray-700"
                      >
                        <span>Customers Info</span>
                      </th>
                        <th
                            scope="col"
                            className="px-12 py-3.5 text-left text-sm font-normal text-gray-700"
                        >
                            Contact Info
                        </th>
                      <th
                        scope="col"
                        className="px-12 py-3.5 text-left text-sm font-normal text-gray-700"
                      >
                        Address
                      </th>
                        <th
                            scope="col"
                            className="px-4 py-3.5 text-left text-sm font-normal text-gray-700"
                        >
                            DOB
                        </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-sm font-normal text-gray-700"
                      >
                        Status
                      </th>

                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-sm font-normal text-gray-700"
                      >
                        Gender
                      </th>
                      <th scope="col" className="relative px-4 py-3.5">
                        <span className="sr-only">Edit</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {people.map((person) => (
                      <tr key={person.id}>
                        <td className="whitespace-nowrap px-4 py-4">
                          <div className="flex items-center">
                            <div className="h-10 w-10 flex-shrink-0">
                              <img
                                className="h-10 w-10 rounded-full object-cover"
                                src={person.img}
                                alt=""
                              />
                            </div>
                            <div className="ml-4">
                              <div className="text-sm font-medium text-gray-900">{person.name}</div>
                              
                            </div>
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-12 py-4">
                            <div className="text-sm text-gray-900 ">{person.phone}</div>
                            <div className="text-sm text-gray-500 ">{person.email}</div>
                        </td>
                        <td className="whitespace-nowrap px-12 py-4 flex">
                          <div className="text-sm text-gray-900 ">  {person.street}, </div>
                            <div className="text-sm text-gray-500 ">{person.city}, </div>
                            <div className="text-sm text-gray-500 ">{person.state}, </div>
                            <div className="text-sm text-gray-500 ">{person.zip}</div>
                          
                        </td>
                        <td className="whitespace-nowrap px-4 py-4">
                            <div className="text-sm text-gray-900 ">{person.dob}</div>
                        </td>
                        <td className="whitespace-nowrap px-4 py-4">
                          {
                          person.active ?
                          <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                            Active
                          </span>
                          :
                          <span className="inline-flex rounded-full bg-red-100 px-2 text-xs font-semibold leading-5 text-red-800">
                            Disabled
                          </span>
                          }
                        </td>
                        <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-700">
                          {person.gender}
                        </td>
                        <td className="whitespace-nowrap px-4 py-4 text-right text-sm font-medium buuton">
                          <div className='text-blue-600'>
                            <Link to={`/editcustomer/${person.id}`}> <FaEdit/> </Link>
                          </div>
                          <div className="text-red-600">
                            <MdDelete/>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}